const IMAGES = {
  logo: require("./images/logowithbrand.png"),
  computer: require("./images/image-computer.png"),
  devices: require("./images/image-devices.png"),
  blacklist: require("./images/icon-blacklist.svg").default,
  text: require("./images/icon-text.svg").default,
  preview: require("./images/icon-preview.svg").default,

  google: require("./images/logo-google.png"),
  ibm: require("./images/logo-ibm.png"),
  microsoft: require("./images/logo-microsoft.png"),
  hp: require("./images/logo-hp.png"),
  vector: require("./images/logo-vector-graphics.png"),

  facebook: require("./images/icon-facebook.svg").default,
  twitter: require("./images/icon-twitter.svg").default,
  instragram: require("./images/icon-instagram.svg").default,
};

export default IMAGES;
